import { render, staticRenderFns } from "./chatSession.vue?vue&type=template&id=0da57418&scoped=true"
import script from "./chatSession.vue?vue&type=script&lang=js"
export * from "./chatSession.vue?vue&type=script&lang=js"
import style0 from "./chatSession.vue?vue&type=style&index=0&id=0da57418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da57418",
  null
  
)

export default component.exports